<div class="channels-pagination">
  <div class="label">Show {{currentIndex + 1}} - {{lastIndex}} of {{totalItems | num}} {{label}}</div>
  <div>
    <button class="btn btn-secondary" [ngClass]="{'disabled': currentPage === 0}" (click)="prevPage()">
      <i class="fa fa-arrow-left"></i>
    </button>
    <button class="btn btn-secondary" [ngClass]="{'disabled': lastIndex >= totalItems }"
            (click)="nextPage()">
      <i class="fa fa-arrow-right"></i>
    </button>
  </div>
</div>
